import React, { useEffect, useState } from 'react';


function LearnWithAIUserTable({ userid, entries }) {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <div
      key={userid}
      style={{
        marginBottom: '1rem',
        border: '1px solid #eee',
        borderRadius: '10px',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          backgroundColor: '#FFEEE0',
          padding: '12px 16px',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontWeight: 'bold',
          color: '#232830',
        }}
        onClick={toggle}
      >
        <span>User ID: {userid}</span>
        <span>{entries.length} Messages {isOpen ? '🔽' : '▶️'}</span>
      </div>

      {isOpen && (
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            fontFamily: 'Nunito Sans',
            fontSize: '14px',
          }}
        >
          <thead>
            <tr style={{ backgroundColor: '#FFF9F3' }}>
              <th style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>Question ID</th>
              <th style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>Question</th>
              <th style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>User Message</th>
              <th style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>AI Response</th>
              <th style={{ padding: '10px', borderBottom: '1px solid #ddd' }}>Model</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((entry, index) => (
              <tr
                key={`${userid}-${index}`}
                style={{
                  backgroundColor: index % 2 === 0 ? '#FFF' : '#FFFBF8',
                  borderBottom: '1px solid #f0f0f0',
                }}
              >
                <td style={{ padding: '10px' }}>{entry.questionid || '-'}</td>
                <td style={{ padding: '10px' }}>{entry.questiontext || '-'}</td>
                <td style={{ padding: '10px' }}>{entry.usermessage || '-'}</td>
                <td style={{ padding: '10px' }}>
                  {entry.airesponse?.length > 80 ? entry.airesponse.slice(0, 80) + '…' : entry.airesponse}
                </td>
                <td style={{ padding: '10px' }}>{entry.modelused || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default LearnWithAIUserTable;
